import {
    MBOX_HIGH_LABEL,
    MBOX_LOW_LABEL,
    MBOX_STANDARD_LABEL,
    MBOX_CUSTOM_LABEL,
    QUICKLINK_VIEWS_LABEL,
    MASTER_DELIVERY_LABEL,
    STORAGE_LABEL,
    S3_DOWNLOADS_LABEL,
    STORAGE_HIGH_VELOCITY_LABEL,
    STORAGE_HIGH_DENSITY_LABEL,
    STORAGE_AWS_GLACIER_LABEL,
    STORAGE_AWS_DEEP_GLACIER_LABEL,
    MOBILE_UPLOADS_LABEL,
    QUICKLINK_DOWNLOADS_LABEL,
    MASTER_DELIVERY_TIER1_LABEL,
    MASTER_DELIVERY_TIER2_LABEL,
    MASTER_DELIVERY_TIER3_LABEL,
    MASTER_DELIVERY_TIER4_LABEL,
    MASTER_DELIVERY_TIER5_LABEL,
    MASTER_DELIVERY_TIER6_LABEL
} from './labels'

export const costSourceDisplayValues = {
    highVelocity: { label: STORAGE_HIGH_VELOCITY_LABEL, color: '#FFCE56' },
    highDensity: { label: STORAGE_HIGH_DENSITY_LABEL, color: '#36A2EB' },
    awsGlacier: { label: STORAGE_AWS_GLACIER_LABEL, color: '#c19ae4' },
    awsDeepGlacier: { label: STORAGE_AWS_DEEP_GLACIER_LABEL, color: '#9FD6E4' },
    Storage: { label: STORAGE_LABEL, color: '#FFCE56' },
    low: { label: MBOX_LOW_LABEL, color: '#c19ae4' },
    standard: { label: MBOX_STANDARD_LABEL, color: '#e4c7a4' },
    high: { label: MBOX_HIGH_LABEL, color: '#b3e4bd' },
    custom: { label: MBOX_CUSTOM_LABEL, color: '#9FD6E4' },
    s3Downloads: { label: S3_DOWNLOADS_LABEL, color: '#e9b5ff' },
    mobileUploads: { label: MOBILE_UPLOADS_LABEL, color: '#7d7ae4' },
    masterDelivery: { label: MASTER_DELIVERY_LABEL, color: '#7CE47B' },
    quicklinkViews: { label: QUICKLINK_VIEWS_LABEL, color: '#FF6384' },
    quicklinkDownloads: { label: QUICKLINK_DOWNLOADS_LABEL, color: '#ffbccb' },
    tier1: { label: MASTER_DELIVERY_TIER1_LABEL, color: '#c19ae4' },
    tier2: { label: MASTER_DELIVERY_TIER2_LABEL, color: '#e4c7a4' },
    tier3: { label: MASTER_DELIVERY_TIER3_LABEL, color: '#b3e4bd' },
    tier4: { label: MASTER_DELIVERY_TIER4_LABEL, color: '#9FD6E4' },
    tier5: { label: MASTER_DELIVERY_TIER5_LABEL, color: '#e9b5ff' },
    tier6: { label: MASTER_DELIVERY_TIER6_LABEL, color: '#7d7ae4' }
}
